import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { useState, useEffect } from 'react';

const  SelectTextFields = ({ label, value, name, handleOnChange, list, arrayIndex , disabled = false, innerIndex}) => {
  const [labelText, setLableText] = useState(`Please Select ${label}`);
  
  useEffect(() => {
    if (name) {
      setLableText(`Select ${name}`);
    } 
    if(label) {
      setLableText(`Select ${label}`);
    }
  }, [label, name]);

  return (
    <Box
      component="form"
      sx={{ '& .MuiTextField-root': { width: '100%', textAlign: 'left' } }}
      noValidate
      autoComplete="off"
    >
      <div>
        <TextField
          id="outlined-select-currency"
          select
          size="small"
          label={labelText}
          value={value}
          name={name}
          disabled = {disabled}
          
          onChange={(event) => {
           
            const selectedOption = list.find(option => option.value === event.target.value);
            handleOnChange(label, event.target.value, selectedOption._id, selectedOption.category_index, event, selectedOption.title, arrayIndex, innerIndex);
          }}
        >
          {list.map((option) => (
            <MenuItem key={option._id} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </div>
    </Box>
  );
}

export default  SelectTextFields